import { useEffect, useState } from 'react';
import { useRestaurant } from '../context/RestaurantContext';

const useFetchTalentsApplication = () => {
  const [talents, setTalents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { restaurantId, loading: restaurantLoading } = useRestaurant();

  const fetchTalentsApplications = async () => {
    // Don't fetch if restaurant context is still loading or no restaurant ID
    if (restaurantLoading || !restaurantId) {
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const url = `${process.env.REACT_APP_BACKEND_STAGING_URL}/api/company/talents-application?restaurantId=${restaurantId}`;
      
      const response = await fetch(url, {
        method: 'GET',
        credentials: 'include', 
      });

      if (!response.ok) {
        throw new Error('Failed to fetch talents');
      }

      const data = await response.json();
      
      // Ensure we always set an array, handle both direct array and wrapped responses
      const talentsArray = Array.isArray(data) ? data : (data.talents || data.data || []);
      setTalents(talentsArray);
    } catch (err) {
      setError(err.message);
      setTalents([]); // Ensure talents remains an empty array on error
      console.error('Error fetching talent applications:', err);
    } finally {
      setLoading(false);
    }
  };

  const triggerFetchTalentsApplications = () => {
    fetchTalentsApplications();
  };

  useEffect(() => {
    fetchTalentsApplications();

    return () => {
    };
  }, [restaurantId]);

  // Listen for restaurant context updated events
  useEffect(() => {
    const handleRestaurantContextUpdated = () => {
      fetchTalentsApplications();
    };

    window.addEventListener('restaurantContextUpdated', handleRestaurantContextUpdated);
    
    return () => {
      window.removeEventListener('restaurantContextUpdated', handleRestaurantContextUpdated);
    };
  }, []);

  return { talents, loading, error, triggerFetchTalentsApplications };
};

export default useFetchTalentsApplication;


